export function getSecondPartFromCamelCase(inputString) {
  const parts = inputString.split(/(?=[A-Z])/);
  return parts.length > 1 ? parts[1] : null;
}
